import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { propsBlocker, getComponentOverride } from '../../../system';

var headerNavigationItemRootStyle = function headerNavigationItemRootStyle(_ref) {
  var HeaderNavigationItem = _ref.theme.componentOverrides.HeaderNavigationItem;
  return HeaderNavigationItem.Root.base;
};

export var HeaderNavigationItemRoot = styled.div.withConfig(propsBlocker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    white-space: nowrap;\n\n    ", "\n    ", ";\n"])), headerNavigationItemRootStyle, getComponentOverride('HeaderNavigationItem'));